/* global analytics */
import { mapActions, mapState, mapGetters } from 'vuex';
import { OPENED_ADMIN_DOCUMENT } from '../analytics';
import { API_URL } from '../constants';

export default {
  metaInfo() {
    if (this.participation) {
      return {
        title: this.participation.attributes.name,
      };
    }
    return {
      title: 'Mon investissement',
    };
  },
  computed: {
    ...mapState('investment', {
      investment: state => state.show,
    }),
    ...mapGetters('investment', ['participation', 'operation', 'spv', 'participationOperation',
      'participationOperations', 'siblings', 'operations']),
    participationDetails() {
      return this.participationOperation.attributes;
    },
    captableUrl() {
      if (this.spv) {
        return `${API_URL}/spvs/${this.spv.attributes.token}/captable_url`;
      }
      return null;
    },
  },
  created() {
    this.fetch({ id: this.$route.params.id });
  },
  methods: {
    ...mapActions('investment', ['fetch']),
    ...mapActions(['openFileViewer']),
    transformDocuments(documents) {
      return (documents || []).map(doc => ({
        id: doc.id,
        text: doc.attributes.description,
        onClick: () => {
          analytics.track(OPENED_ADMIN_DOCUMENT, {
            docId: doc.id,
            text: doc.attributes.description,
          });
          return this.openFileViewer(doc);
        },
      }));
    },
  },
};
